export default __webpack_public_path__ + "static/media/virtual-tour-slide-5-desktop.3000edf6.png";